export default [
  {
    path: "/page/userInstructionDeleteAccount",
    name: "userInstruction",
    meta: { name: "Инструкция" },
    component: () => import("@/views/viewUserInstruction/viewUserInstruction.vue"),
  }
]
